/* eslint-disable */
import React, { useState, useEffect } from "react";
import "./Dashboard.css";
import "./yoda.css";
import Sidebar from "../../../components/worker/sidebar/SidebarWorker";
import Navbar from "../../../components/worker/navbar/Navbar2";
import Footer from "../../../components/worker/footer/Footer";
import { notification } from "antd";
import { useSelector } from "react-redux";
import { getAuth, onAuthStateChanged } from "firebase/auth";
import { useLocation } from "react-router-dom";
import { useMemo } from "react";
import { db } from "../../../firebase";
import DashboardCardsDigital from "./dashboardComposants/DashboardCardsDigital";
import { Timestamp, setDoc, doc, arrayUnion } from "firebase/firestore";
import CrispChat from "../../../components/CrispChat";
import DashboardCards from "./dashboardComposants/DashboardCards";
import BrowsersCard from "./dashboardComposants/BrowsersCard";
import BigChart from "./dashboardComposants/BigChart";
import AdsChart from "./dashboardComposants/socialMediaChart";
import MostDemandedProducts from "./dashboardComposants/MostDemandedProducts";
import { useTranslation } from "react-i18next";

function WorkerDashboard() {
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const isRTL = i18n.language === "ar";
  const match = useMemo(() => {
    const match = location.pathname.match(/^\/sawa9ly\/(.+)$/);
    return match ? match[1] : null;
  }, [location.pathname]);

  const [orders, setOrders] = useState([]);
  const stateOrders = useSelector((state) => state.OrdersReducer);
  const [showSideBar, setShowSideBar] = useState(true);
  const products = useSelector((state) => state.ProductsReducer);
  const store = useSelector((state) => state.StoreReducer);
  const worker = useSelector((state) => state.workerReducer);
  const permissions = worker?.permissions || {};

  const auth = getAuth();
  const [api, contextHolder] = notification.useNotification();
  const UAParser = require("ua-parser-js");
  useEffect(() => {
    let unsubscribe = null;

    const setupOrdersListener = async () => {
      const today = new Date();
      today.setHours(0, 0, 0, 0);

      const startOfToday = today.getTime();
      const now = Date.now();

      let list = stateOrders
        .filter((order) => {
          if (!order.timeStamp) return false;
          const orderTime = order.timeStamp.seconds * 1000;
          return orderTime >= startOfToday && orderTime <= now;
        })

        // product mode filter
        // .filter((order) => {
        //   if (account?.productMode === "digital") {
        //     return order.type === "digitalProducts";
        //   }
        //   return true;
        // })

        // deleted filter
        .filter((order) => order.deleted !== 1)

        // sort by descending date
        .sort((a, b) => b.timeStamp.seconds - a.timeStamp.seconds);

      setOrders(
        list.map((item, index) => ({
          ...item,
          index: list.length - index + 999,
        }))
      );
    };

    onAuthStateChanged(auth, async (user) => {
      if (user) {
        console.log("User is authenticated, setting up orders listener...");
        await setupOrdersListener();
        const deviceData = await getDeviceData();

        if (worker) {
          const workerData = worker;
          const devices = workerData.devices || [];
          const deviceExists = devices.some(
            (device) => device.deviceName === deviceData.deviceName
          );

          if (workerData.isActive === false) {
            await setDoc(
              doc(db, "workers", workerData.id),
              {
                isActive: true,
              },
              { merge: true }
            );
          }

          if (!deviceExists) {
            await setDoc(
              doc(db, "workers", worker.id),
              {
                devices: arrayUnion(deviceData),
                isActive: true,
              },
              { merge: true }
            );
          }
        }
      }
    });

    return () => {
      if (unsubscribe) {
        unsubscribe();
      }
    };
  }, [store.visits, worker]);

  useEffect(() => {
    function handleResize() {
      if (window.innerWidth <= 1080) {
        setShowSideBar(false);
      } else {
        setShowSideBar(true);
      }
    }

    window.addEventListener("resize", handleResize);

    handleResize();

    return () => {
      window.removeEventListener("resize", handleResize);
    };
  }, []);

  const getGeolocation = () => {
    return new Promise((resolve, reject) => {
      if (navigator.geolocation) {
        navigator.geolocation.getCurrentPosition(
          (position) => resolve(position),
          (error) => reject(error)
        );
      } else {
        reject("Geolocation is not supported by this browser.");
      }
    });
  };

  const getDeviceData = async () => {
    const userAgent = navigator.userAgent;

    const parser = new UAParser();
    const result = parser.getResult();

    let location = null;

    try {
      const position = await getGeolocation();
      location = {
        latitude: position.coords.latitude,
        longitude: position.coords.longitude,
      };
    } catch (error) {
      console.error("Could not get location", error);
      location = { latitude: null, longitude: null };
    }

    return {
      deviceName: userAgent || "Unknown Device",
      deviceType: result.device.model || "Unknown Type",
      os: result.os.name || "Unknown OS",
      osVersion: result.os.version || "Unknown Version",
      location,
      isLoggedIn: true,
      timestamp: Timestamp.fromDate(new Date()),
    };
  };

  return (
    <div className="container-fluid" dir={isRTL ? "rtl" : "ltr"}>
      <div className="row">
        {showSideBar && (
          <div
            style={{
              width: "250px",
              flexShrink: 0,
              transition: "width 0.6s ease",
            }}
          >
            <Sidebar
              showSideBar={showSideBar}
              setShowSideBar={setShowSideBar}
            />
          </div>
        )}
        <div
          className="px-3 w-full mt-12 dark:!bg-[#141414]"
          style={{ flex: 1 }}
        >
          <Navbar showSideBar={showSideBar} setShowSideBar={setShowSideBar} />
          {contextHolder}
          <CrispChat />
          <div className="m-3 p-0 mt-16">
            {/* <Skeleton active loading={loading} paragraph={{ rows: 4 }}> */}
            {/* <Carousel style={{ marginTop: "12px" }}> */}
            {[
              "/banners/banner desktop.png",
              // "pcbanner3.jpg",
              // "pcbanner1.jpg",
              // "pcbanner2.jpg",
              // "pcbanner4.jpg",
            ].map((src, index) => (
              // <Carousel.Item key={index}>
              <img
                className="d-block w-100"
                src={src}
                alt={t("ui.slideNumber", { value0: (index) })}
                style={{ borderRadius: "12px" }}
              />
              // </Carousel.Item>
            ))}
            {/* </Carousel> */}
            {/* </Skeleton> */}
          </div>
          {(worker?.productMode ?? "classic") === "classic" ? (
            <DashboardCards />
          ) : (
            <DashboardCardsDigital />
          )}

          <div className="w-full p-4">
            <div className="md:col-span-2 grid grid-cols-1 md:grid-cols-5 gap-4">
              <BigChart />
              <BrowsersCard />
              <MostDemandedProducts products={products} />
              <AdsChart />
            </div>

            <div className="mt-4">
              {/* {orders.length > 0 && (
                <DataTableTemplatingDemoDashboard
                  filter=""
                  orders={
                    (worker?.productMode ?? "classic") === "classic"
                      ? orders.filter((order) => order.deleveryStatus === "1")
                      : orders.filter(
                          (order) =>
                            order.status == 1 ||
                            order.status === 2 ||
                            order.status == 3
                        )
                  }
                  pageSize={10}
                />
              )} */}
            </div>
          </div>
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default WorkerDashboard;
